import { FinalTermRule } from "@terms/models";

export const redirectToPreviousPageIfAnyTermDeclined: FinalTermRule = {
  condition: (outstandingTerms) => outstandingTerms.some((term) => !term.accepted),
  action: ({ history }) => history.goBack(),
};
